const configService = {
    // apiUrl: 'http://ortografiacerebral/wp-json'
    apiUrl: 'http://localhost:8888/ortografiacerebral/wp-json'
}

export default configService


// WEBPACK FOOTER //
// ./src/ws/config.js